import * as React from "react"
import './Header.scss'

import Logo from "../../images/logo.png"

const Header = () => {
  return (
    <div className="header">
      <img src={Logo} alt="how much money is that logo" />
    </div>
  )
}

export default Header
